import { Thunk, thunk, Action, action } from 'easy-peasy'
import productsApi from '../api/resources/products'
import { Product } from '@libs/types/generated/rates-research-api'

export interface ProductsModel {
  products: Product[]
  setProducts: Action<ProductsModel, Product[]>
  fetchProducts: Thunk<ProductsModel>
}

const productsModel: ProductsModel = {
  // State
  products: [],

  // actions
  setProducts: action((state, payload) => {
    state.products = payload
  }),

  // thunks
  fetchProducts: thunk(async actions => {
    const products = await productsApi.getAll()
    actions.setProducts(products)
  })
}

export default productsModel
